import React, { ReactElement, useState } from 'react';
import PageWithTabs, { IRoute } from 'components/Layout/PageWithTabs';
import { RouteComponentProps, Redirect, Route, withRouter } from 'react-router-dom';
import PosIdCheck from 'Router/PosIdCheck';
import appRoutes from 'Router/routes';
import { OfferTemplateType } from 'localTypes';
import PageHeaderWithSelectPOS from 'components/Layout/PageHeaderWithSelectPOS';
import { GlobalLoader } from 'components/Loader';
import { OfferTemplateMapper } from 'services/offerService';

interface IProps {
    routes: IRoute[];
    offerTemplateType: OfferTemplateType;
    pageTitle: string;
    icon: ReactElement;
    pos?: any;
}

const adaptRoutes = (routes: IRoute[], pos: any) => {
    const hasRatingTab = routes.find((item) => item.tabKey === 'orderRating');

    if(hasRatingTab){
        const ratingAvailable = pos?.zone?.holding?.rating;
        routes = ratingAvailable ? routes : routes.filter(item => item.tabKey !== 'orderRating');
    }

    return routes;
};

const PageContent = ({ routes, offerTemplateType, pageTitle, icon, pos }: IProps) => {
    const [currentTabIndex, setCurrentTabIndex] = useState(0);
    const routeParam = OfferTemplateMapper[offerTemplateType];
    routes = adaptRoutes(routes, pos);

    return (
        <PageWithTabs
            routes={routes}
            indexRoute={appRoutes[routeParam].index()}
            HeaderComponent={() => (
                <PageHeaderWithSelectPOS
                    title={pageTitle}
                    offerTemplateType={offerTemplateType}
                    icon={icon}
                    hideSelectLayoutPOS={routes[currentTabIndex]?.hideSelectLayoutPOS}
                />
            )}
            onChangeTab={setCurrentTabIndex}
        />
    );
};

const TradePage = ({
    match: {
        params: { idHolding },
    },
    icon,
    offerTemplateType,
    routes,
    pageTitle,
}: IProps & RouteComponentProps<{ idHolding?: string }>) => {
    const routeParam = OfferTemplateMapper[offerTemplateType];
    return (
        <PosIdCheck offerTemplateType={offerTemplateType}>
            {(loading, pos) => (
                <>
                    <Route
                        exact
                        path={appRoutes[routeParam].posSelect()}
                        render={(props) =>
                            pos ? (
                                <Redirect {...props} to={appRoutes[routeParam].index(idHolding, pos.id)} />
                            ) : (
                                <PageHeaderWithSelectPOS
                                    title={pageTitle}
                                    offerTemplateType={offerTemplateType}
                                    icon={icon}
                                />
                            )
                        }
                    />
                    <Route
                        path={`${appRoutes[routeParam].index()}/:tab?`}
                        render={(props) => {
                            const {
                                match: {
                                    params: { 
                                      // @ts-ignore
                                      idPos 
                                    },
                                },
                            } = props;
                            if (loading) return <GlobalLoader />;
                            return pos && pos.id === idPos ? (
                                <PageContent
                                    routes={routes}
                                    pageTitle={pageTitle}
                                    offerTemplateType={offerTemplateType}
                                    icon={icon}
                                    pos={pos}
                                />
                            ) : (
                                <Redirect {...props} to={appRoutes[routeParam].posSelect(idHolding)} />
                            );
                        }}
                    />
                </>
            )}
        </PosIdCheck>
    );
};

export default withRouter(TradePage);
